<template>
  <div class="order-details">
    <!-- 给header上与data上加on为退款订单-->
    <template>
      <div
        class="writeOff"
      >
        <div class="title">核销信息</div>
        <div class="grayBg">
          <div class="pictrue">
            <vue-qr class="bicode" qid="qrimg" :callback="qrload" :logoScale="20" :text="couponInfo.verify_code" :margin="0" :dotScale="1"></vue-qr>
          </div>
        </div>
        <div class="gear"><img src="@assets/images/writeOff.jpg" /></div>
        <div class="num">{{ couponInfo.verify_code }}</div>
        <div class="rules">
          <div class="item">
            <div class="rulesTitle acea-row row-middle">
              <span class="iconfont icon-shuoming1"></span>使用说明
            </div>
            <div class="info">可将二维码出示给店员扫描或提供数字核销码</div>
          </div>
        </div>
      </div>
    </template>
    <div class="wrapper">
      <div class="item acea-row row-between">
        <div>核销码：</div>
        <div class="conter acea-row row-middle row-right">
          {{ couponInfo.verify_code
          }}<span
            class="copy copy-data"
            @click="copy"
            :data-clipboard-text="couponInfo.verify_code"
            >复制</span
          >
        </div>
      </div>
      <div class="item acea-row row-between">
        <div>优惠券名称：</div>
        <div class="conter">
          {{ couponInfo.coupon_title }}
        </div>
      </div>
      <div class="item acea-row row-between">
        <div>优惠券面额：</div>
        <div class="conter">
          {{ couponInfo.coupon_price }}元
        </div>
      </div>
      <div class="item acea-row row-between">
        <div>最低消费：</div>
        <div class="conter">
          {{ couponInfo.use_min_price }}元
        </div>
      </div>
      <div class="item acea-row row-between" v-if="couponInfo.status!=2">
        <div>过期时间：</div>
        <div class="conter">
          {{ couponInfo.is_forever > 0 ? '永久' : couponInfo._end_time }}
        </div>
      </div>
      <div class="item acea-row row-between" v-if="couponInfo.is_fail==0">
        <div>使用状态：</div>
        <div class="conter" v-if="couponInfo.status==0">
          未使用
        </div>
        <div class="conter" v-if="couponInfo.status==1">
          已使用
        </div>
        <div class="conter" v-if="couponInfo.status==2">
          已过期
        </div>
      </div>
      <div class="item acea-row row-between" v-else>
        <div>使用状态：</div>
        <div class="conter" v-if="couponInfo.status==0">
          未支付或无效
        </div>
      </div>
    </div>

  </div>
</template>
<style scoped>
.geoPage {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  z-index: 10000;
}
.order-details .writeOff {
  background-color: #fff;
  margin-top: 0.13rem;
  padding-bottom: 0.3rem;
}
.order-details .writeOff .title {
  font-size: 0.3rem;
  color: #282828;
  height: 0.87rem;
  border-bottom: 1px solid #f0f0f0;
  padding: 0 0.3rem;
  line-height: 0.87rem;
}
.order-details .writeOff .grayBg {
  background-color: #f2f5f7;
  width: 5.9rem;
  height: 3.84rem;
  border-radius: 0.2rem 0.2rem 0 0;
  margin: 0.5rem auto 0 auto;
  padding-top: 0.55rem;
}
.order-details .writeOff .grayBg .pictrue {
  width: 2.9rem;
  height: 2.9rem;
  margin: 0 auto;
}
.order-details .writeOff .grayBg .pictrue img {
  width: 100%;
  height: 100%;
  display: block;
}
.order-details .writeOff .gear {
  width: 5.9rem;
  height: 0.3rem;
  margin: 0 auto;
}
.order-details .writeOff .gear img {
  width: 100%;
  height: 100%;
  display: block;
}
.order-details .writeOff .num {
  background-color: #f0c34c;
  width: 5.9rem;
  height: 0.84rem;
  color: #282828;
  font-size: 0.48rem;
  margin: 0 auto;
  border-radius: 0 0 0.2rem 0.2rem;
  text-align: center;
  padding-top: 0.04rem;
}
.order-details .writeOff .rules {
  margin: 0.46rem 0.3rem 0 0.3rem;
  border-top: 0.01rem solid #f0f0f0;
  padding-top: 0.1rem;
}
.order-details .writeOff .rules .item {
  margin-top: 0.15rem;
}
.order-details .writeOff .rules .item .rulesTitle {
  font-size: 0.28rem;
  color: #282828;
}
.order-details .writeOff .rules .item .rulesTitle .iconfont {
  font-size: 0.3rem;
  color: #333;
  margin-right: 0.08rem;
  margin-top: 0.05rem;
}
.order-details .writeOff .rules .item .info {
  font-size: 0.28rem;
  color: #999;
  margin-top: 0.05rem;
}
.order-details .writeOff .rules .item .info .time {
  margin-left: 0.2rem;
}
.order-details .map {
  height: 0.86rem;
  font-size: 0.3rem;
  color: #282828;
  line-height: 0.86rem;
  border-bottom: 0.01rem solid #f0f0f0;
  margin-top: 0.13rem;
  background-color: #fff;
  padding: 0 0.3rem;
}
.order-details .map .place {
  font-size: 0.26rem;
  width: 1.76rem;
  height: 0.5rem;
  border-radius: 0.25rem;
  line-height: 0.5rem;
  text-align: center;
}
.order-details .map .place .iconfont {
  font-size: 0.27rem;
  height: 0.27rem;
  line-height: 0.27rem;
  margin: 0.02rem 0.03rem 0 0;
}
.order-details .address .name .iconfont {
  font-size: 0.34rem;
  margin-left: 0.1rem;
}
</style>
<script>
import {couponDetail} from "@api/user";
import {mapGetters} from "vuex";
import vueQr from 'vue-qr'

const NAME = "CouponDetails";

export default {
  name: NAME,
  components: {
    vueQr
  },
  props: {},
  data: function() {
    return {
      id: this.$route.params.id,
      couponInfo: {
      },
    };
  },
  computed: {
    ...mapGetters(["userInfo"])
  },
  watch: {
    $route(n) {
      if (n.name === NAME && this.id !== n.params.id) {
        this.id = n.params.id;
        this.getDetail();
      }
    }
  },
  inject: ["app"],
  mounted: function() {
    this.getDetail();
  },
  methods: {
    copy() {
      let clipboard = new this.Clipboard(".copy-data");
      clipboard.on("success", () => {
        this.$dialog.success("复制成功");
        // 释放内存
        clipboard.destroy();
      });
    },
    getDetail() {
      const id = this.id;
      if (!id) return this.$dialog.error("优惠券不存在");
      couponDetail(id)
        .then(res => {
          this.couponInfo = res.data
        })
        .catch(err => {
          this.$dialog.error(err.msg);
        });
    },
  }
};
</script>
